var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-body" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading != 0,
            expression: "loading != 0"
          }
        ],
        staticClass: "row"
      },
      [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")]),
            _vm._v(" "),
            _c("ring-loader")
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading == 0,
            expression: "loading == 0"
          }
        ]
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("singleselect", {
                attrs: {
                  name: "package",
                  title: _vm.trans("bag_item.entity.package"),
                  options: _vm.packages,
                  checked: _vm.bagItem.package,
                  errors: _vm.form.options.errors,
                  label: "name"
                },
                model: {
                  value: _vm.bagItem.package,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "package", $$v)
                  },
                  expression: "bagItem.package"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("number-input", {
                attrs: {
                  name: "priceBeforeDiscount",
                  errors: _vm.form.options.errors,
                  title: _vm.trans("bag.entity.price_before_discount"),
                  disabled: true
                },
                model: {
                  value: _vm.bagItem.priceBeforeDiscount,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "priceBeforeDiscount", $$v)
                  },
                  expression: "bagItem.priceBeforeDiscount"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("singleselect", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: {
                      content: _vm.disableMenuChange
                        ? _vm.trans("form.errors.time_frame_exceeded")
                        : null,
                      trigger: "hover",
                      placement: "top"
                    },
                    expression:
                      "{\n                            content: disableMenuChange ? trans('form.errors.time_frame_exceeded') : null,\n                            trigger: 'hover',\n                            placement: 'top',\n                        }"
                  }
                ],
                attrs: {
                  name: "variant",
                  title: _vm.trans("bag_item.entity.variant"),
                  options: _vm.variants,
                  checked: _vm.bagItem.variant,
                  errors: _vm.form.options.errors,
                  label: "name",
                  disabled: _vm.disableMenuChange
                },
                model: {
                  value: _vm.bagItem.variant,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "variant", $$v)
                  },
                  expression: "bagItem.variant"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("text-input", {
                attrs: {
                  name: "priceDiscount",
                  errors: _vm.form.options.errors,
                  title: _vm.trans("bag.entity.price_discount"),
                  disabled: true
                },
                model: {
                  value: _vm.priceDiscountDisplay,
                  callback: function($$v) {
                    _vm.priceDiscountDisplay = $$v
                  },
                  expression: "priceDiscountDisplay"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("singleselect", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: {
                      content: _vm.disableMenuChange
                        ? _vm.trans("form.errors.time_frame_exceeded")
                        : null,
                      trigger: "hover",
                      placement: "top"
                    },
                    expression:
                      "{\n                            content: disableMenuChange ? trans('form.errors.time_frame_exceeded') : null,\n                            trigger: 'hover',\n                            placement: 'top',\n                        }"
                  }
                ],
                attrs: {
                  name: "mealType",
                  title: _vm.trans("bag_item.entity.meal_type"),
                  options: _vm.mealTypes,
                  checked: _vm.bagItem.mealType,
                  errors: _vm.form.options.errors,
                  "show-route-name": "meal_type_show",
                  label: "name",
                  disabled: _vm.disableMenuChange
                },
                on: { dispatch: _vm.getSizes },
                model: {
                  value: _vm.bagItem.mealType,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "mealType", $$v)
                  },
                  expression: "bagItem.mealType"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("number-input", {
                attrs: {
                  name: "priceAfterDiscount",
                  errors: _vm.form.options.errors,
                  title: _vm.trans("bag.entity.price_after_discount"),
                  disabled: true
                },
                model: {
                  value: _vm.bagItem.priceAfterDiscount,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "priceAfterDiscount", $$v)
                  },
                  expression: "bagItem.priceAfterDiscount"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("singleselect", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: {
                      content: _vm.disableMenuChange
                        ? _vm.trans("form.errors.time_frame_exceeded")
                        : null,
                      trigger: "hover",
                      placement: "top"
                    },
                    expression:
                      "{\n                            content: disableMenuChange ? trans('form.errors.time_frame_exceeded') : null,\n                            trigger: 'hover',\n                            placement: 'top',\n                        }"
                  }
                ],
                attrs: {
                  name: "size",
                  title: _vm.trans("bag_item.entity.size"),
                  options: _vm.sizes,
                  checked: _vm.bagItem.size,
                  errors: _vm.form.options.errors,
                  label: "name",
                  disabled: _vm.disableMenuChange
                },
                model: {
                  value: _vm.bagItem.size,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "size", $$v)
                  },
                  expression: "bagItem.size"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("number-input", {
                attrs: {
                  name: "takenFromMoneyboxAfterDiscount",
                  errors: _vm.form.options.errors,
                  title: _vm.trans(
                    "bag_item.entity.taken_from_moneybox_after_discount"
                  ),
                  step: 0.01,
                  disabled: true
                },
                model: {
                  value: _vm.bagItem.takenFromMoneyboxPriceChanges,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "takenFromMoneyboxPriceChanges", $$v)
                  },
                  expression: "bagItem.takenFromMoneyboxPriceChanges"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("singleselect", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: {
                      content: _vm.disableResignElement
                        ? _vm.trans("form.errors.time_frame_exceeded")
                        : null,
                      trigger: "hover",
                      placement: "top"
                    },
                    expression:
                      "{\n                            content: disableResignElement ? trans('form.errors.time_frame_exceeded') : null,\n                            trigger: 'hover',\n                            placement: 'top',\n                        }"
                  }
                ],
                attrs: {
                  name: "status",
                  title: _vm.trans("bag_item.entity.status"),
                  options: _vm.statuses,
                  checked: _vm.bagItem.status,
                  errors: _vm.form.options.errors,
                  label: "value",
                  "show-route-name": "tag_show",
                  disabled: _vm.disableResignElement
                },
                model: {
                  value: _vm.bagItem.status,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "status", $$v)
                  },
                  expression: "bagItem.status"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("number-input", {
                attrs: {
                  name: "takenFromWalletAfterDiscount",
                  errors: _vm.form.options.errors,
                  title: _vm.trans(
                    "bag_item.entity.taken_from_wallet_after_discount"
                  ),
                  step: 0.01,
                  disabled: true
                },
                model: {
                  value: _vm.bagItem.priceTakenFromWalletPriceChanges,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.bagItem,
                      "priceTakenFromWalletPriceChanges",
                      $$v
                    )
                  },
                  expression: "bagItem.priceTakenFromWalletPriceChanges"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-6" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-6" },
              [
                _c("number-input", {
                  attrs: {
                    name: "priceLeftToPayPriceChanges",
                    errors: _vm.form.options.errors,
                    title: _vm.trans("order.entity.price_left_to_pay"),
                    step: 0.01,
                    disabled: true
                  },
                  model: {
                    value: _vm.bagItem.priceLeftToPayPriceChanges,
                    callback: function($$v) {
                      _vm.$set(_vm.bagItem, "priceLeftToPayPriceChanges", $$v)
                    },
                    expression: "bagItem.priceLeftToPayPriceChanges"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-6" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-6" },
            [
              _c("number-input", {
                attrs: {
                  name: "vatRate",
                  errors: _vm.form.options.errors,
                  title: _vm.trans("bag_item.entity.vat_rate")
                },
                model: {
                  value: _vm.bagItem.vatRate,
                  callback: function($$v) {
                    _vm.$set(_vm.bagItem, "vatRate", $$v)
                  },
                  expression: "bagItem.vatRate"
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d802888", { render: render, staticRenderFns: staticRenderFns })
  }
}